import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    empresa: '',
    presupuesto: '',
    msg: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.nombre || !formData.email || !formData.email.includes('@')) {
      alert('Por favor, completa al menos tu nombre y un email válido.');
      return;
    }
    setSubmitted(true);
  };
  return <section className="relative overflow-hidden text-center py-[130px]" id="contacto" data-id="element-10">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_120%,rgba(196,255,61,0.16),transparent_55%)] pointer-events-none" data-id="element-11"></div>

      <div className="max-w-wrap mx-auto px-7 relative z-10" data-id="element-12">
        <motion.h2 initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10%'
      }} transition={{
        duration: 0.8,
        ease: [0.2, 0.7, 0.2, 1]
      }} className="text-[clamp(2.4rem,6.5vw,5rem)] font-bold tracking-[-0.035em] leading-none" data-id="element-13">
          ¿Listo para{' '}
          <span className="font-serif italic font-normal text-acid" data-id="element-14">ganar</span>
          ?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10%'
      }} transition={{
        duration: 0.8,
        ease: [0.2, 0.7, 0.2, 1],
        delay: 0.07
      }} className="max-w-[46ch] mx-auto mt-[26px] text-ink-dim text-[1.15rem]" data-id="element-15">
          Solicita una auditoría gratuita de tu cuenta de Meta Ads. Te decimos
          exactamente qué está fallando y qué haríamos nosotros — sin
          compromiso.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10%'
      }} transition={{
        duration: 0.8,
        ease: [0.2, 0.7, 0.2, 1],
        delay: 0.14
      }} className="max-w-[560px] mx-auto mt-[54px] text-left" data-id="element-16">
          {!submitted ? <form onSubmit={handleSubmit} data-id="element-17">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-[14px]" data-id="element-18">
                <div className="mb-[14px]" data-id="element-19">
                  <label htmlFor="nombre" className="block text-[0.78rem] text-ink-faint mb-[7px] font-mono tracking-[0.05em]" data-id="element-20">
                    NOMBRE
                  </label>
                  <input type="text" id="nombre" placeholder="Tu nombre" className="w-full bg-card border border-line-strong rounded-[12px] p-[14px_16px] text-ink font-sans text-[0.96rem] transition-all duration-250 focus:outline-none focus:border-acid focus:shadow-[0_0_0_3px_rgba(196,255,61,0.12)]" value={formData.nombre} onChange={e => setFormData({
                ...formData,
                nombre: e.target.value
              })} data-id="element-21" />
                </div>
                <div className="mb-[14px]" data-id="element-22">
                  <label htmlFor="email" className="block text-[0.78rem] text-ink-faint mb-[7px] font-mono tracking-[0.05em]" data-id="element-23">
                    EMAIL
                  </label>
                  <input type="email" id="email" placeholder="tucorreo@empresa.com" className="w-full bg-card border border-line-strong rounded-[12px] p-[14px_16px] text-ink font-sans text-[0.96rem] transition-all duration-250 focus:outline-none focus:border-acid focus:shadow-[0_0_0_3px_rgba(196,255,61,0.12)]" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} data-id="element-24" />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-[14px]" data-id="element-25">
                <div className="mb-[14px]" data-id="element-26">
                  <label htmlFor="empresa" className="block text-[0.78rem] text-ink-faint mb-[7px] font-mono tracking-[0.05em]" data-id="element-27">
                    EMPRESA / MARCA
                  </label>
                  <input type="text" id="empresa" placeholder="Nombre de tu negocio" className="w-full bg-card border border-line-strong rounded-[12px] p-[14px_16px] text-ink font-sans text-[0.96rem] transition-all duration-250 focus:outline-none focus:border-acid focus:shadow-[0_0_0_3px_rgba(196,255,61,0.12)]" value={formData.empresa} onChange={e => setFormData({
                ...formData,
                empresa: e.target.value
              })} data-id="element-28" />
                </div>
                <div className="mb-[14px]" data-id="element-29">
                  <label htmlFor="presupuesto" className="block text-[0.78rem] text-ink-faint mb-[7px] font-mono tracking-[0.05em]" data-id="element-30">
                    INVERSIÓN MENSUAL EN ADS
                  </label>
                  <select id="presupuesto" className="w-full bg-card border border-line-strong rounded-[12px] p-[14px_16px] text-ink font-sans text-[0.96rem] transition-all duration-250 focus:outline-none focus:border-acid focus:shadow-[0_0_0_3px_rgba(196,255,61,0.12)] appearance-none" value={formData.presupuesto} onChange={e => setFormData({
                ...formData,
                presupuesto: e.target.value
              })} data-id="element-31">
                    <option value="" data-id="element-32">Selecciona…</option>
                    <option data-id="element-33">Aún no invierto</option>
                    <option data-id="element-34">Menos de 1.000€</option>
                    <option data-id="element-35">1.000€ – 5.000€</option>
                    <option data-id="element-36">5.000€ – 20.000€</option>
                    <option data-id="element-37">Más de 20.000€</option>
                  </select>
                </div>
              </div>

              <div className="mb-[14px]" data-id="element-38">
                <label htmlFor="msg" className="block text-[0.78rem] text-ink-faint mb-[7px] font-mono tracking-[0.05em]" data-id="element-39">
                  CUÉNTANOS TU SITUACIÓN
                </label>
                <textarea id="msg" placeholder="¿Qué vendes y qué quieres conseguir?" className="w-full bg-card border border-line-strong rounded-[12px] p-[14px_16px] text-ink font-sans text-[0.96rem] transition-all duration-250 focus:outline-none focus:border-acid focus:shadow-[0_0_0_3px_rgba(196,255,61,0.12)] resize-y min-h-[90px]" value={formData.msg} onChange={e => setFormData({
              ...formData,
              msg: e.target.value
            })} data-id="element-40"></textarea>
              </div>

              <button type="submit" className="w-full justify-center mt-2 bg-acid text-[#0a0c0b] py-[19px] px-[38px] rounded-full font-bold text-[1.1rem] transition-all duration-250 inline-flex items-center gap-[10px] hover:-translate-y-[3px] hover:shadow-[0_14px_40px_rgba(196,255,61,0.32)] group" data-id="element-41">
                Solicitar auditoría gratuita{' '}
                <span className="transition-transform duration-250 group-hover:translate-x-1 group-hover:-translate-y-1" data-id="element-42">
                  ↗
                </span>
              </button>

              <p className="text-center text-ink-faint text-[0.8rem] mt-4" data-id="element-43">
                Respondemos en menos de 24h laborables. Tus datos solo se usan
                para contactarte.
              </p>
            </form> : <div className="text-center p-[30px] border border-acid rounded-[16px] bg-[rgba(196,255,61,0.05)] text-ink" data-id="element-44">
              <div className="text-[2.4rem] mb-[10px]" data-id="element-45">✓</div>
              <strong className="text-[1.3rem]" data-id="element-46">¡Recibido!</strong>
              <p className="text-ink-dim mt-2" data-id="element-47">
                Gracias por tu interés. El equipo de LEADS AND WIN revisará tu
                caso y te escribirá muy pronto.
              </p>
            </div>}
        </motion.div>
      </div>
    </section>;
}